<template>
  <div class="xz-live-header" @click="down">
    <div>
      <img :src="imgSrc" alt="小筑教育" class="logo f-l-l" />
      <div class="f-l-l text">
        <p>下载小筑教育APP</p>
        <p>观看直播更流程</p>
      </div>
      <van-button icon="down" type="primary" class="f-l-r" size="mini" color="#486e98" style="margin-top:10px;margin-right:20px">立即下载</van-button>
    </div>
    <van-overlay :show="show" @click="show = false" style="z-index: 99999999999999">
      <div class="wrapper" @click.stop >
        <van-image :src="openRow" class="Invite f-l-r m-r-075"></van-image>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import { getAppClient } from "@/utils/commonUtils";

export default {
  data() {
    return {
      imgSrc: require("@/assets/imgs/logo.png"),
      show: false,
      openRow: require("@/assets/imgs/weChat/openRow.png"),
    };
  },
  methods:{
    down() {
      if (getAppClient() == "JSAPI") {
        this.show = true;
        return false
      }
      // 下载app
      let data = {
        type: 1,
      };
      if (!this.AndroisIos()) data.type = 2;
      this.Api({
        url: "api/getVersionNum",
        method: "POST",
        data,
      }).then((res) => {
        if (res.retuCode == 5000) {
          if (!this.isNotNull(res.data.pkgUrl)) {
            let text = "安卓系统暂未开通app,很快就会上线";
            if (data.type == 2) text = "ios系统暂缓开通app,很快就会上线~";
            alert(text);
            return false;
          }
          window.open(res.data.pkgUrl);
        }
      });
    },
  }
};
</script>

<style scoped>
.xz-live-header {
  height: 8vh;
  background-color: #dce8f5;
  overflow: hidden;
  position: absolute;
  width: 100%;
  z-index: 9999999 !important;
}
.logo {
  width: 4.15rem;
  height: 1.05rem;
  margin-top: 15px;
  margin-left: 18px;
}
.text {
  color: #486e98;
  font-size: 12px;
  padding-left: 20px;
  padding-top: 10px;
}
</style>